import type { GetServerSideProps } from 'next';

import { CONSIDERATION_CONTENT_SLUGS } from '../../../src/client/ahm-constants/ui';
import ConsiderationLandingPageTemplate, {
  ConsiderationLandingPageProps,
  getTemplateServerSideProps,
} from '../../../components/page-templates/consideration-landing-page-template';

const slug = CONSIDERATION_CONTENT_SLUGS.YOUTH_DISCOUNT_PAGE;

const YouthDiscountPage = ({
  activeOffers: serverSideOffers,
  placeholders: serverSidePlaceholders,
  serverSideData,
}: ConsiderationLandingPageProps) => (
  <ConsiderationLandingPageTemplate
    activeOffers={serverSideOffers}
    placeholders={serverSidePlaceholders}
    serverSideData={serverSideData}
    slug={slug}
  />
);

export const getServerSideProps: GetServerSideProps = getTemplateServerSideProps({ slug });

export default YouthDiscountPage;
